import { useTranslation } from 'react-i18next';

import { AjaxSelect } from '@/components/Ui/Form/Rhf/AjaxSelect';
import { FieldWithLabel } from '@/components/Ui/Form/Rhf/FieldWithLabel';
import { LocaleSelect } from '@/components/Ui/Form/Rhf/LocaleSelect';
import { PasswordField } from '@/components/Ui/Form/Rhf/PasswordField';
import { Select } from '@/components/Ui/Form/Rhf/Select';
import auth from '@/helpers/auth';
import { toArray } from '@/helpers/enums';

export function SettingsForm() {
    const [
        t,
    ] = useTranslation('pages');

    return (
        <div className='space-y-8 divide-y divide-border'>
            <div className='flex flex-col gap-y-2 lg:grid grid-cols-2 gap-4'>
                <div>
                    <FieldWithLabel
                        inline
                        name='first_name'
                        verbose
                    />
                </div>

                <div>
                    <FieldWithLabel
                        inline
                        name='last_name'
                        verbose
                    />
                </div>

                <div>
                    <FieldWithLabel
                        Element={ Select }
                        className=''
                        elementProps={ {
                            options: toArray('price_display', (val) => {
                                return val.toUpperCase().replace('_', ' ');
                            }),
                        } }
                        inline
                        name='price_display'
                        required
                        verbose
                    />
                </div>

                <div>
                    <FieldWithLabel
                        Element={ LocaleSelect }
                        className=''
                        inline
                        name='locale'
                        verbose
                    />
                </div>

                { (auth.isAdministrator() || auth.isSimulatingClient()) && (
                    <div>
                        <FieldWithLabel
                            Element={ AjaxSelect }
                            className=''
                            elementProps={ {
                                ajaxUrl: '/api/workspaces',
                                isClearable: true,
                            } }
                            inline
                            name='active_workspace_id'
                            verbose
                        />
                    </div>
                ) }

                <div className='lg:col-start-1'>
                    <FieldWithLabel
                        Element={ PasswordField }
                        inline
                        name='password'
                        verbose
                    />
                    <div className='m-4 text-xs'>
                        <div className='font-bold mb-2'>{ t('Password requirements:') }</div>
                        <ul>
                            <li>{ t('Minimum length of 8 characters.') }</li>
                            <li>{ t('Must contain a mix of upper and lower case letters.') }</li>
                            <li>{ t('Must include numbers.') }</li>
                            <li>{ t('Must have symbols.') }</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <FieldWithLabel
                        Element={ PasswordField }
                        inline
                        name='password_confirmation'
                        verbose
                    />
                </div>
            </div>
        </div>
    );
}

export default SettingsForm;
